<template>
  <div
    class="live-room"
    :style="{ background: passwordFlag ? '#fff' : 'transparent' }"
  >
    <section class="loading-box">
      <!-- 播放器和操作部分 -->
      <div class="room-content" v-show="videoShowFlag">
        <section class="live-view-box clear">
          <div class="live-view-l fl">
            <div class="video-box" ref="barrage_wrap">
              <div class="room-title">
                <span class="room-title-link" @click="back">
                  <i class="ipng Shape_07"></i>
                  <strong>{{ videoName }}</strong>
                </span>
              </div>
              <!-- <hjPlayer
                v-if="videoShowFlag && playerOption.play_url"
                id="hjPlayer"
                height="691"
                :playerOption.sync="playerOption"
              ></hjPlayer> -->
              <liveDPlayer v-if="videoShowFlag && playerOption.play_url" style="height: 690px;"
                :live_Options.sync="playerOption"></liveDPlayer>
            </div>
            <div class="barrage-switch">
              <span
                :class="[barrageOrNot ? '' : 'white-switch']"
                @click="changeBarrageStatus"
                >{{
                  barrageOrNot
                    ? $t("homepage.barrageOpen")
                    : $t("homepage.barrageOff")
                }}</span
              >
            </div>
          </div>
          <div class="live-view-r fr">
            <template>
              <el-tabs class="view-r-tabs" v-model="activeDiscuss">
                <el-tab-pane name="1" class="discuss-tab-pane">
                  <span slot="label"
                    ><i
                      class="el-icon-chat-dot-square"
                      style="font-size: 18px; vertical-align: middle"
                    ></i>
                    {{ $t("homepage.discuss") }}</span
                  >
                  <vue-scrollbar
                    class="my-scrollbar discuss-scrollbar"
                    ref="Scrollbar"
                  >
                    <ul class="discuss-ul" id="dicussUl">
                      <li
                        class="clear"
                        v-for="(item, index) of discussData"
                        :key="index"
                      >
                        <span
                          :class="[
                            userId == item.create_id
                              ? 'speaker-name green-c'
                              : 'speaker-name',
                          ]"
                          >{{ item.user_name }}:</span
                        >
                        <p class="speak-words">
                          {{ item.content }}
                        </p>
                      </li>
                      <div v-if="discussData.length === 0" class="no-data-tip">
                        - {{ $t("global.noData") }} -
                      </div>
                    </ul>
                  </vue-scrollbar>
                  <div class="sendcomment-box">
                    <el-input
                      :placeholder="$t('homepage.yourWord')"
                      maxlength="40"
                      v-model="content"
                      @keyup.enter.native="checkForbidden"
                    >
                      <el-button slot="append" @click="checkForbidden">{{
                        $t("global.submit")
                      }}</el-button>
                    </el-input>
                  </div>
                </el-tab-pane>
                <el-tab-pane name="2" class="member-tab-pane">
                  <span slot="label"
                    ><i
                      class="el-icon-user"
                      style="font-size: 18px; vertical-align: middle"
                    ></i>
                    {{ $t("homepage.member") }}</span
                  >
                  <vue-scrollbar class="my-scrollbar member-scrollbar">
                    <ul class="member-ul">
                      <li v-for="(item, index) of onlineUserData" :key="index">
                        <template>
                          <span
                            class="member-name"
                            :title="item.name"
                            :class="[userId == item.id ? 'green-c' : '']"
                          >
                            {{ item.name }}
                          </span>
                          <span
                            class="member-identity"
                            :title="item.role_name"
                            :class="[userId == item.id ? 'green-c' : '']"
                          >
                            <i>{{ item.role_name }}</i>
                          </span>
                        </template>
                        <template v-if="item.check_power == true">
                          <i
                            class="mic-icon-allow"
                            v-if="item.live_forbidden_flag == false"
                            @click="
                              forbidWords(item.id, item.live_forbidden_flag)
                            "
                          ></i>
                          <i
                            class="mic-icon-forbid"
                            v-else
                            @click="
                              forbidWords(item.id, item.live_forbidden_flag)
                            "
                          ></i>
                        </template>
                        <template v-else>
                          <i class="mic-icon-allow admin-allow"></i>
                        </template>
                      </li>
                    </ul>
                  </vue-scrollbar>
                </el-tab-pane>
              </el-tabs>
            </template>
          </div>
        </section>
      </div>
    </section>

    <!-- 直播的介绍 -->
    <section class="live-info-detail">
      <div class="live-info-container">
        <ul>
          <li>
            <span>{{ $t("homepage.liveName") }}</span>
            <span>{{ videoName }}</span>
          </li>
          <li>
            <span>{{ $t("homepage.liveTime") }}</span>
            <span>{{ timeString }}</span>
          </li>
          <li>
            <span>{{ $t("homepage.onlineCounts") }}</span>
            <span>{{ $t("homepage.onlineCounts") }}：{{ onlineCounts }}</span>
          </li>
          <li>
            <span>{{ $t("homepage.liveIntr") }}</span>
            <span
              class="live-tinymce"
              v-html="profile ? profile : $t('global.noData')"
            ></span>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>
<script>
// import hjPlayer from "@/components/common/hjPlayer";
import liveDPlayer from "@/components/common/liveDPlayer"
import VueScrollbar from "vue2-scrollbar";
import { setInterval } from "timers";
require("vue2-scrollbar/dist/style/vue2-scrollbar.css");
export default {
  components: {
    liveDPlayer,
    // hjPlayer,
    VueScrollbar,
  },
  data() {
    return {
      videoSign: "",
      userId:
        sessionStorage.getItem("user_info_str") &&
        JSON.parse(sessionStorage.getItem("user_info_str")).id, //当前用户的id
      liveId: this.$route.query.id, //当前直播的id
      checkingInterval: null, //检测直播是否结束
      bigLiveData: {}, //当前直播详细数据
      // 输入密码才能看功能：
      passCode: "",
      passwordFlag: false, //true时，显示直播密码窗口；false时，显示直播内容

      //当前直播视频信息：
      videoName: "",
      profile: "",
      onlineCounts: 0,
      timeString: "", //直播的结束时间
      gradeInfo: "",
      // 视频：
      videoShowFlag: false,
      playerOption: {
        type: "flv",
        play_url: "",
      },
      // 讨论区/笔记
      activeDiscuss: "1",
      //评论区
      isTeacher: "", //是否是老师发言
      discussData: [],
      content: "",
      forbidFlag: false, //没被禁言
      // 在线成员
      onlineUserId: [], //所有在线用户的id
      onlineUserData: [],

      //弹幕
      barrageOrNot: false,
      barrage: null, //弹幕对象
    };
  },
  created() {},
  mounted() {
    this.getVideo();
    this.addLiveRecord();
    this.getDiscussList();

    this.$nextTick(function () {
      this.websocket();
    });

    //设置计时器检查直播是否被删除
    this.checkingInterval = setInterval(this.checkLiveEnd, 20000);
  },
  methods: {
    //添加直播记录
    addLiveRecord() {
      let success = (data) => {};
      let fail = (data) => {
        this.$router.push({ path: "/home/liveList" });
      };
      this.$ajax({
        url: "api/live/live_user_list",
        method: "post",
        data: {
          id: this.liveId,
        },
        func: {
          success: success,
          fail: fail,
        },
      });
    },
    // 检测直播是否被删除：
    checkLiveEnd() {
      let success = (res) => {};
      let fail = (res) => {
        this.$message.warning(this.$t("homepage.liveOver"));
        this.$router.push({
          path: "/home/liveList",
        });
        clearInterval(this.checkingInterval._id);
      };
      this.$ajax({
        url: "api/live/check_is_liveend",
        method: "get",
        params: {
          liveid: this.liveId,
        },
        func: {
          success: success,
          fail: fail,
        },
      });
    },
    // 讨论区
    getDiscussList() {
      let success = (res) => {
        this.discussData = res.data;
        if (res.data.length != 0) {
          this.someMethod();
        }
      };
      this.$ajax({
        url: "api/live/live_discuss",
        method: "get",
        params: {
          liveid: this.liveId,
          is_teacher: this.isTeacher,
        },
        func: {
          success: success,
        },
      });
    },
    checkForbidden() {
      if (localStorage.getItem("token")) {
        if (this.userId == 0) {
          this.$message.error(this.$t("homepage.needLogin"));
          return;
        }

        if (!this.content.trim()) {
          this.$message.warning(this.$t("homepage.yourWord"));
          return;
        }

        let success = (res) => {
          if (res.data == "true") {
            this.forbidFlag = true;
          } else {
            this.forbidFlag = false;
          }
          this.sendComment();
        };

        this.$ajax({
          url: "api/live/check_forbidden",
          method: "get",
          params: {
            liveid: this.liveId,
            now_userid: this.userId,
          },
          func: {
            success: success,
          },
        });
      } else {
        this.$message.warning(this.$t("homepage.needLogin"));
      }
    },
    // 发送信息
    sendComment() {
      let success = (res) => {
        if (this.forbidFlag) {
          this.$message.warning(this.$t("homepage.forbit"));
        } else {
          let message = JSON.stringify({
            type: "say",
            room_id: this.liveId,
            content: this.content,
          });
          // console.log('发送数据...:', message)
          this.ws.send(message);
        }
      };
      this.$ajax({
        url: "api/live/check_forbidden",
        method: "get",
        params: {
          liveid: this.liveId,
          now_userid: this.userId,
        },
        func: {
          success: success,
        },
      });
    },
    //滚动条
    someMethod() {
      this.$nextTick(() => {
        if (document.getElementById("dicussUl")) {
          let h = document.getElementById("dicussUl").clientHeight;
          this.$refs.Scrollbar.scrollToY(h);
        }
      });
    },
    websocket() {
      //gateway
      // 监听端口
      let str = "ws://" + this.BASE_URL.substring(7, 21) + ":7373";
      this.ws = new WebSocket(str);
      //加载时向gateway发送信息定义房间号
      this.ws.onopen = () => {
        var message = JSON.stringify({
          type: "login",
          uid: this.userId,
          room_id: this.liveId,
        });
        this.ws.send(message);
      };
      this.ws.onmessage = (evt) => {
        var data = JSON.parse(evt.data);
        if (data.status == "error") {
          this.content = ""; //清空输入框
          return this.$message.warning(this.$t("homepage.forbit2"));
        }

        switch (data.type) {
          case "receive": //发送信息
            this.discussData.push(data.data);
            this.someMethod();
            this.content = ""; //清空输入框
            //弹幕滚动
            this.barrageOrNot &&
              this.barrage({
                text: data.data.content,
                color: this.userId == data.data.create_id ? "#dc2904" : "#fff",
                speed: 3,
                classname: 1,
                size: 24,
              });
            break;
          case "all_count": //统计所有在线人数，一个页面相当于一个客户端
            // this.onlineCounts = data.num;
            break;
          case "user_count": //统计所有登录用户在线人数
            for (let i in data.all_uid) {
              this.onlineUserId.push(data.all_uid[i]);
            }
            this.getOnlineUser();
            break;
          default:
            break;
        }
        // console.log('数据已接收...:', data)
      };
      this.ws.onclose = function () {
        // 关闭 websocket
        // console.log('连接已关闭...')
      };
      // 组件销毁时调用，中断websocket链接
      this.over = () => {
        this.ws.close();
      };
    },
    //获取所有登录用户的数据
    getOnlineUser() {
      let success = (res) => {
        this.onlineUserData = res.data;
        this.onlineCounts = res.data.length;
      };
      this.$ajax({
        url: "api/live/live_online_user_list",
        method: "get",
        params: {
          live_id: this.liveId,
          uid: this.onlineUserId,
        },
        func: {
          success: success,
        },
      });
    },
    // 获取直播的视频数据：
    getVideo() {
      let success = (data) => {
        //视频信息
        this.liveId = data.data.id;
        sessionStorage.setItem(
          "sharePath",
          this.BASE_URL + "/home/liveRoom?id=" + data.data.id
        );
        this.videoSign = data.data.live_sign;
        this.bigLiveData = data.data;
        this.videoName = data.data.name;
        this.profile = data.data.profile;
        this.timeString =
          data.data.start_time.slice(0, 10) == data.data.end_time.slice(0, 10)
            ? data.data.start_time.slice(0, -3) +
              " ~ " +
              data.data.end_time.slice(10).slice(0, -3)
            : data.data.start_time.slice(0, -3) +
              " ~ " +
              data.data.end_time.slice(0, -3);

        // 拼接直播对应班级信息字符串
        if (data.data.studyname != null) {
          this.gradeInfo += data.data.studyname + ">";
        }
        if (data.data.gradename != null) {
          this.gradeInfo += data.data.gradename + ">";
        }
        if (data.data.subjectname != null) {
          this.gradeInfo += data.data.subjectname;
        }
        this.playerOption.play_url = data.data.play_url //赋值播放流地址
        if (this.playerOption.play_url) {
          this.videoShowFlag = true; //显示视频播放器
        }
      };
      this.$ajax({
        url: "api/live/live",
        method: "get",
        params: {
          live_sign: sessionStorage.getItem("live_sign"),
        },
        func: { success },
      });
    },
    // 弹幕
    changeBarrageStatus() {
      this.barrageOrNot = !this.barrageOrNot;
    },
    // 回上一页
    back() {
      this.$router.push({
        path: "/home/liveList",
      });
    },
  },
};
</script>
<style lang="scss">
.live-room {
  min-height: calc(100vh - 44px);
  overflow: hidden;

  .share_text {
    font-size: 16px;

    .el-radio-group {
      margin: 20px 0 15px 0;
    }

    .el-radio__label {
      font-size: 15px;
    }
  }

  .videoPlayer-dimensions.vjs-fluid {
    padding-top: 0;
  }

  .emoji {
    width: 25px;
    height: 25px;
  }

  .room-title {
    background: #ffffff;
    padding-left: 35px;
    height: 50px;
    line-height: 50px;
    box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
  }

  .room-title-link {
    cursor: pointer;

    i,
    strong {
      vertical-align: middle;
    }

    strong {
      font-size: 18px;
      font-weight: 600;
      color: #333;
      margin-left: 15px;
    }
  }

  .room-share {
    .a-tit {
      height: 28px;
      line-height: 28px;
      font-size: 14px;
      color: #656e6c;
      margin-right: 10px;
    }
  }

  .loading-box {
    height: calc(100% - 307px);
    min-height: calc(100vh - 100px);
  }

  .room-content {
    padding: 20px 0;
  }

  .live-view-box {
    max-width: 1875px;
    margin: 0 auto;
    height: 802px;
  }

  .live-view-l {
    display: inline-block;
    width: calc(1496/1875 * 100%);

    .video-box {
      display: inline-block;
      width: 100%;
      height: 740px;
      position: relative;
      background-image: url("../../../assets/images/image_couse.png");
      background-size: 100% 100%;

      #newDom {
        height: calc(100% - 49px);
        overflow: hidden;
      }

      .barrage {
        font-size: 24px;
      }
    }
  }

  .live-check-box {
    height: calc(100vh - 322px);
    min-height: 882px;
    background-color: rgba(0, 0, 0, 0.8);
    position: relative;
  }

  .unlogin-box {
    display: inline-block;
    width: 100%;
    min-height: 882px;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.8);
    position: relative;

    .unlogin-container {
      display: inline-block;
      width: 644px;
      height: 400px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -200px;
      /*height的一半*/
      margin-left: -322px;
      /*width的一半*/
    }

    .limit-tips {
      margin-top: 40px;
      font-size: 16px;

      .need-login {
        color: #909eaf;

        i {
          color: #E62125;
          padding-left: 10px;
        }
      }

      .not-allow {
        font-size: 18px;
        color: #b9d9ff;
        line-height: 24px;
        margin: 26px 0 38px;
      }

      .check-area {
        color: #E62125;
        cursor: pointer;
        line-height: 21px;
      }

      .forbid-area {
        color: #909eaf;
        line-height: 21px;
      }
    }

    .forbid-content {
      padding: 20px 0 0;
      text-align: center;

      span {
        margin-left: 5px;
        font-size: 16px;
        color: #fff;
        line-height: 21px;
      }

      .check-more-btn {
        color: #E62125;
        cursor: pointer;
      }
    }
  }

  .common-password-box {
    display: inline-block;
    width: 100%;
    height: 100%;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.8);
    position: relative;

    .container {
      display: inline-block;
      width: 400px;
      height: 400px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -200px;
      /*height的一半*/
      margin-left: -200px;
      /*width的一半*/
    }

    .tips {
      margin-top: 52px;

      p {
        line-height: 28px;
      }

      p:nth-child(1) {
        font-size: 16px;
        color: #fff;
      }

      p:nth-child(2) {
        font-size: 14px;
        color: #fff;
        text-align: left;
        padding-left: 1em;
      }
    }

    .enter-tip {
      font-size: 12px;
      color: #cfcfcf;
      margin: 34px 0;
      text-align: left;
    }

    .error-tip {
      font-size: 16px;
      color: #ff4949;
      margin: 10px 0 25px;
      text-align: left;
    }

    .code-box {
      width: 424px;
      height: 60px;
      position: relative;
      margin: 0 0 20px 10px;

      .code-input-line {
        position: absolute;
        left: 0;
        bottom: 0;
        content: "";
        color: #fff;
        width: 380px;
        height: 4px;
        background-image: linear-gradient(
          to right,
          #fff 0%,
          #fff 90%,
          transparent 50%
        );
        background-size: 64px 2px;
        background-repeat: repeat-x;
      }

      .code-input {
        position: absolute;
        left: 0;
        top: 0;

        .el-input__inner {
          border: 1px solid transparent;
          height: 65px;
          line-height: 65px;
          color: #fff;
          font-size: 40px;
          letter-spacing: 45px;
          background-color: transparent;
        }
      }
    }

    .enter-live-btn {
      padding: 0;
      width: 380px;
      height: 40px;
    }
  }

  .barrage-switch {
    height: 62px;
    line-height: 62px;
    background-color: #fff;
    cursor: pointer;

    span {
      display: inline-block;
      min-width: 80px;
      height: 26px;
      padding: 0 10px;
      line-height: 26px;
      text-align: center;
      border-radius: 13px;
      font-size: 12px;
      margin-left: 20px;
      background-color: #3a486f;
      color: #fff;
    }

    .white-switch {
      background-color: #999;
    }
  }

  .live-view-r {
    display: inline-block;
    width: calc(360/1875 * 100%);
    height: 100%;
    background-color: #fff;

    nav {
      span {
        display: inline-block;
        width: 100%;
        // width: 50%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        cursor: pointer;

        i {
          vertical-align: middle;
          font-size: 14px;
          margin: 0 4px;
        }
      }

      .lActive {
        color: #4298b1;
        background: #a8ecfd;
      }
    }

    .view-r-tabs {
      // margin-top: 20px;

      .el-tabs__header {
        margin: 0;

        .el-tabs__nav-wrap {
          height: 48px;
          line-height: 48px;

          .el-tabs__nav-scroll {
            .el-tabs__nav {
              width: 100%;

              .el-tabs__item {
                width: 50%;
                text-align: center;
                // &.is-active{
                //     color: #0059AA;
                // }
              }

              .el-tabs__active-bar {
                display: none;
              }
            }
          }
        }
      }

      .el-tabs__content {
        height: 802 - 48px;

        .el-tab-pane.discuss-tab-pane {
          height: 100%;

          .my-scrollbar.discuss-scrollbar.vue-scrollbar__wrapper {
          }
        }
      }
    }

    .green-c {
      color: #3bb080;
    }

    .discuss-scrollbar {
      height: 641px;
      height: calc(100% - 61px);
    }

    .vue-scrollbar__scrollbar-vertical {
      width: 6px;
    }

    .vue-scrollbar__scrollbar-vertical .scrollbar {
      width: 6px;
      background-color: #338efc;
      border-radius: 2px;
    }

    .vue-scrollbar__scrollbar-vertical .scrollbar:hover {
      width: 6px;
      background-color: #000;
      border-radius: 2px;
    }

    .no-data-tip {
      text-align: center;
      color: #dcdfe6;
      margin-top: 250px;
    }

    .discuss-ul {
      font-size: 12px;
      color: #020202;
      padding: 20px 0;

      li {
        padding: 0 20px;
      }

      .speaker-name {
        display: inline-block;
        width: 80px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-right: 25px;
        line-height: 25px;
        float: left;
      }

      .speak-words {
        display: inline-block;
        width: calc(100% - 120px);
        line-height: 25px;
        float: left;
        word-wrap: break-word;
        word-break: break-all;
      }
    }

    .sendcomment-box {
      border-top: 1px solid #e0e0e0;
      padding: 10px 20px;

      .el-button {
        border-radius: 0 4px 4px 0;
        color: #fff;
        background-color: #338efc;
        border: 1px solid #338efc;
      }
    }

    .member-scrollbar {
      height: 702px;
    }

    .member-ul {
      font-size: 12px;
      color: #020202;
      padding-top: 10px;

      li {
        padding: 0 20px;
        height: 30px;
        line-height: 30px;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
      }

      .member-name {
        display: inline-block;
        max-width: 80px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-right: 20px;
        float: left;
      }

      .member-identity {
        max-width: 160px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        float: left;
      }

      .mic-icon-allow,
      .mic-icon-forbid {
        float: right;
        display: inline-block;
        width: 30px;
        height: 30px;
        cursor: pointer;
      }

      .mic-icon-allow {
        background: url(../../../assets/images/ipng.png) -610px -732px no-repeat;
      }

      .mic-icon-forbid {
        background: url(../../../assets/images/ipng.png) -570px -732px no-repeat;
      }

      .admin-allow {
        cursor: no-drop;
      }
    }
  }

  .live-info-detail {
    margin: 0 auto 40px;
    max-width: 1875px;
    // background-color: #fff;
    min-height: 205px;
    overflow: hidden;
    // margin: 20px auto 0;

    .live-info-container {
      box-sizing: border-box;
      padding: 0 40px;
      // padding: 0 25px;
      width: calc(1496/1875 * 100%);
      background: #fff;

      ul {
        padding-top: 22px;

        > li {
          overflow: hidden;
          padding: 14px 0;
          border-bottom: 1px solid #efefef;

          &:last-child {
            border: 0 none;
          }

          > span {
            line-height: 20px;
            font-size: 14px;

            &:first-child {
              float: left;
              width: 120px;
              color: #999999;
            }

            &:nth-child(2) {
              display: block;
              overflow: hidden;
            }
          }
        }
      }
    }

    h2 {
      font-size: 16px;
      font-weight: 600;
      padding: 40px 0 25px;
    }

    .live-info {
      margin-bottom: 30px;

      span {
        display: inline-block;
        height: 18px;
        line-height: 18px;
        margin-right: 25px;
        color: gray;
      }

      i {
        vertical-align: middle;
      }

      .clock-icon,
      .man-icon,
      .more-icon {
        display: inline-block;
        width: 18px;
        height: 18px;
        margin-right: 5px;
      }

      .clock-icon {
        background: url("../../../assets/images/clock-icon.png") no-repeat;
      }

      .man-icon {
        background: url("../../../assets/images/man-icon.png") no-repeat;
      }

      .more-icon {
        background: url("../../../assets/images/more-icon.png") no-repeat;
      }
    }

    p {
      font-size: 14px;
    }
  }

  .img-card {
    position: relative;
    margin: 10px;

    .el-card__body {
      height: 100px;

      img {
        width: 100%;
        height: 100%;
        object-fit: fill;
      }
    }
  }

  .tips-word {
    visibility: hidden;
    opacity: 0;
    width: 100%;
    height: 140px;
    line-height: 140px;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(144, 147, 153, 0.5);
    text-align: center;

    span {
      padding: 20px;
      font-size: 20px;
      font-weight: 600;
      letter-spacing: 5px;
      border: 2px dashed #fff;
      color: #fff;
      cursor: pointer;
    }
  }

  .img-card .el-card__body:hover > .tips-word {
    visibility: visible;
    opacity: 1;
  }

  .seePicDialog {
    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__headerbtn {
      border-radius: 50%;
      top: -12px;
      right: -12px;
      padding: 3px;
      background-color: #fff;

      .el-dialog__close {
        padding: 3px;
        border-radius: 50%;
        background-color: #666;
        color: #fff;
      }

      .el-dialog__close:hover {
        background-color: #409eff;
      }
    }
  }

  .member-tab-pane {
    position: relative;

    .member-tips {
      position: absolute;
      bottom: 4px;
      left: 4px;
      font-size: 12px;
      color: #999;
      z-index: 0;
    }
  }

  .live-tinymce {
    padding-bottom: 50px;
    line-height: 1.5;
    word-wrap: break-word;
    word-break: break-all;

    img {
      max-width: 100% !important;
      height: auto !important;
      object-fit: contain;
    }
  }
}
</style>
